import React, { useState } from 'react';
import { toast } from 'sonner';
import { useMakeRequest } from '../../hooks/useMakeRequest';
import { APPLICATION_API } from '../../resources/resource';
import LoadSpinner from '../Modals/LoadSpinner';

function ScheduleTable({ refetch, data, title, handleInterview }) {
  const [loading, setLoading] = useState(false)
  const makeRequest = useMakeRequest()

  const handleUpdate = async (applicationId) => {
    makeRequest(
      APPLICATION_API + `/updateApplication/${applicationId}`,
      'PUT',
      {status: 'Interviewed'},
      ()=>{
        setLoading(false)
        refetch()
      },
      (error)=>{console.log(error)},
      ()=>{
        setLoading(false)
      }
    )
  };

  return (
    <div className="mt-6 text-sm">
      <table className="w-full mx-auto border-collapse">
        <thead>
          <tr className="border-b-2 border-orange-300">
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">S/N</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Name</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Description</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Date of Interview</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Time of Interview</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Time Remaining</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Remark</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((eachData, index) => {
            const timeRemaining = Date.now();
            const timeOfInterview = eachData.interviews[0]?.interviewTime || 'N/A'; // Default to first interview or fallback
            const dateOfInterview = eachData.interviews[0]?.interviewDate || 'N/A';
            const interviewDay = new Date(`${dateOfInterview}T${timeOfInterview}:00`);
            const timeLeftInMilliseconds = interviewDay - timeRemaining;
            const timeLeftInHours = timeLeftInMilliseconds > 0 ? (timeLeftInMilliseconds / (3600000 * 24)).toFixed(2) : 'Passed';

            return (
              <tr
                key={eachData._id || index} // Use unique ID if available
                className="border-b border-gray-200 hover:bg-orange-50 transition-colors duration-200"
              >
                <td className="px-6 py-3 text-gray-800 text-xs font-medium uppercase">{index + 1}</td>
                <td className="px-6 py-3 text-gray-800 text-xs font-medium uppercase">
                  {`${eachData.applicant[0]?.firstName || ''} ${eachData.applicant[0]?.lastName || ''}`}
                </td>
                <td className="px-6 py-3 text-gray-800 text-xs font-medium uppercase">{eachData.job?.jobTitle || 'N/A'}</td>
                <td className="px-6 py-3 text-gray-800 text-xs font-medium uppercase">{dateOfInterview}</td>
                <td className="px-6 py-3 text-gray-800 text-xs font-medium uppercase">{timeOfInterview}</td>
                <td className="px-6 py-3 text-gray-800 text-xs font-medium uppercase">
                  {timeLeftInHours !== 'Passed' ? `${timeLeftInHours} hrs` : 'Passed'}
                </td>
                <td className="px-6 py-3 text-green-700 text-xs font-medium uppercase">{eachData.status || 'N/A'}</td>
                <td className="px-6 py-3 flex space-x-2">
                  <button
                    className="bg-gray-500 text-white px-3 py-1 rounded-md hover:bg-green-600 transition-colors duration-150 text-xs font-medium uppercase"
                    onClick={(e) => handleInterview(e)}
                  >
                    Start
                  </button>
                  <button
                    className="bg-gray-500 text-white px-3 py-1 rounded-md hover:bg-green-600 transition-colors duration-150 text-xs font-medium uppercase"
                    onClick={() => handleUpdate(eachData._id)}
                  >
                    {loading ? 
                    <LoadSpinner/>
                    : 'Interview Done' 
                    }
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ScheduleTable;